import axios from 'axios';

export const orgId = "cdp3d";

export const baseUrl = "https://backend.cdp3d.com/";
// export const baseUrl = "https://cdp3d.com/";

const url = baseUrl + orgId + "/";

export const productsUrl = url + "products/";
export const couponsUrl = url + "coupons/";
export const searchUrl = url + "products/search/";
export const ordersUrl = url + "orders/";

// Axios Wrapper Functions
export const fetchContacts = () => axios.get(baseUrl + 'contact');
export const deleteContact = (id) => axios.delete(baseUrl + 'contact/' + id);

export const fetchEnquiries = () => axios.get(baseUrl + 'enquiry');
export const deleteEnquiry = (id) => axios.delete(baseUrl + 'enquiry/' + id);

export const fetchReviews = () => axios.get(baseUrl + 'reviews/all/list');
export const deleteReview = (id) => axios.delete(baseUrl + 'reviews/' + id);

export { url };